import './sticky-button.scss'

import htmx from 'htmx.org'

let checkoutObserver

htmx.onLoad((content) => {
  const anchor = content.querySelector('#checkout-anchor')
  const container = content.querySelector('#sticky-checkout-container')

  if (anchor && container) {
    if (checkoutObserver) {
      checkoutObserver.disconnect()
    }

    checkoutObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]

        // button is outside (below) of the visible viewport
        if (!entry.isIntersecting && entry.boundingClientRect.top > 0) {
          container.classList.add('is-sticky')
        } else {
          container.classList.remove('is-sticky')
        }
      },
      { rootMargin: '0px 0px 10px 0px', threshold: 0 },
    )

    checkoutObserver.observe(anchor)
  }
})
